/**
 * Detects if the app is running in helpdesk-only mode
 * based on the hostname (e.g., helpdesk.cruvzmail.com).
 */
export function isHelpdeskMode(): boolean {
  return window.location.hostname.startsWith('helpdesk.');
}

/**
 * Detects if the app is running on a custom/white-label domain
 * (i.e. NOT the main cruvzmail.com platform domain).
 * Custom domains should show the direct login form, not the marketing landing page.
 */
export function isCustomDomain(): boolean {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return false;
  if (hostname === 'cruvzmail.com' || hostname === 'www.cruvzmail.com') return false;
  if (hostname.endsWith('.cruvzmail.com')) return false;
  return true;
}
